if (!customElements.get('setup-popup')) {
  class SetupPopup extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('.setup-popup__tab'));
      this.panels = Array.from(this.querySelectorAll('.setup-popup__panel'));

      this.querySelector('.setup-popup__close')?.addEventListener('click', () => this.close());

      this.addEventListener('click', (e) => {
        if (e.target === this) this.close();
      });

      this._onKeydown = (e) => {
        if (e.key === 'Escape' && this.hasAttribute('open')) this.close();
      };
      this._onHashChange = () => {
        if (window.location.hash === '#setup') this.open();
      };
      this._onLinkClick = (e) => {
        const link = e.target.closest('a[href]');
        if (!link) return;
        const href = link.getAttribute('href');
        if (href === '#setup' || href.endsWith('#setup')) {
          e.preventDefault();
          history.pushState(null, '', '#setup');
          this.open();
        }
      };

      document.addEventListener('keydown', this._onKeydown);
      window.addEventListener('hashchange', this._onHashChange);
      document.addEventListener('click', this._onLinkClick);

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.switchTab(parseInt(tab.dataset.tab, 10)));
      });

      this.querySelectorAll('.setup-popup__video-wrap').forEach((wrap) => {
        const video = wrap.querySelector('video');
        const playBtn = wrap.querySelector('.setup-popup__play-btn');

        if (!video || !playBtn) return;

        playBtn.addEventListener('click', () => video.play());
        video.addEventListener('play', () => wrap.classList.add('is-playing'));
        video.addEventListener('pause', () => wrap.classList.remove('is-playing'));
        video.addEventListener('ended', () => wrap.classList.remove('is-playing'));
      });

      if (window.location.hash === '#setup') {
        setTimeout(() => this.open(), 150);
      }
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this._onKeydown);
      window.removeEventListener('hashchange', this._onHashChange);
      document.removeEventListener('click', this._onLinkClick);
    }

    open() {
      this.setAttribute('open', '');
    }

    close() {
      this.removeAttribute('open');
      this.pauseAll();
      history.pushState(null, '', window.location.pathname + window.location.search);
    }

    switchTab(index) {
      this.tabs.forEach((tab, i) => {
        tab.classList.toggle('is-active', i === index);
        tab.setAttribute('aria-selected', String(i === index));
      });

      this.panels.forEach((panel, i) => {
        const isActive = i === index;
        panel.classList.toggle('is-active', isActive);
        panel.toggleAttribute('hidden', !isActive);

        if (!isActive) {
          const video = panel.querySelector('video');
          if (video && !video.paused) video.pause();

          const iframe = panel.querySelector('iframe');
          if (iframe) {
            try {
              iframe.contentWindow.postMessage(
                '{"event":"command","func":"pauseVideo","args":""}',
                '*'
              );
            } catch (_) {}
          }
        }
      });
    }

    pauseAll() {
      this.querySelectorAll('video').forEach((v) => {
        if (!v.paused) v.pause();
      });

      this.querySelectorAll('iframe').forEach((iframe) => {
        try {
          iframe.contentWindow.postMessage(
            '{"event":"command","func":"pauseVideo","args":""}',
            '*'
          );
        } catch (_) {}
      });
    }
  }

  customElements.define('setup-popup', SetupPopup);
}
